import React from "react";
import {Divider, Grid, Typography} from "@mui/material";
import {GradientButton, GradientText} from "./GradientComponents";
import samplePrompts, {SamplePrompt} from "../data/samplePrompts";
import ChatsIcon from "../icons/ChatsIcon";
import Paper from "@mui/material/Paper/Paper";

const NewChatPage = (props: NewChatPageProps ) => {
    return <Paper style={{height: '100%', backgroundColor: "#FAF9FE"}}>
        <Grid container style={{ padding: "0 24px"}}
              direction="column"
              display={"flex"}>
            <GradientText style={{
                fontSize: "36px",
                fontWeight: 500,
                marginTop: "24px",
                marginBottom: "16px",
                background: "linear-gradient(270deg, #DB3B5C 0%, #8937A5 46.57%, #455AC7 100%))"
            }}>
                Nebula Chat
            </GradientText>
            <Typography variant={"body2"} style={{fontSize: "14px"}}>
                Select a sample prompt or write your own prompt to begin the chat. Prompts are instructions or cues you provide to Nebula to generate specific output.
            </Typography>
            <Typography variant={"body2"}
                        style={{fontWeight: "600", marginTop: "24px", marginBottom: "12px"}}>
                Sample prompts:
            </Typography>
            <Grid display={"flex"} direction={"row"} gap={"24px"} justifyContent={"space-evenly"}>
                {
                    samplePrompts.map((prompt, index) => {
                        const {description} = prompt;
                        return (<Grid
                            key={index} xs={6} md={3} style={{
                            flexGrow: 1,
                            flexShrink: 1,
                            flexBasis: 0
                        }}>
                            <GradientButton style={{
                                padding: "6px 12px",
                                borderRadius: 8,
                                backgroundColor: "white",
                                fontWeight: "normal",
                                width: "100%"
                            }} onClick={() => props.onSamplePromptClick(prompt)}>{description}</GradientButton>
                        </Grid>)
                    })
                }
            </Grid>
            <Grid container mb={2} mt={2} display={"flex"} direction={"row"} alignItems={"center"}>
                <Grid item xs={5.625} md={5.625}>
                    <Divider variant="fullWidth"/>
                </Grid>
                <Grid item xs={0.75} md={0.75} style={{textAlign: "center"}}>
                    <Typography>or</Typography>
                </Grid>
                <Grid item xs={5.625} md={5.625}>
                    <Divider variant="fullWidth"/>
                </Grid>
            </Grid>
            <Grid container xs={12} md={12} display={"flex"} direction={"row"} justifyContent={"center"}>
                <GradientButton style={{borderRadius: 999, padding: "4px 20px"}}
                                startIcon={<ChatsIcon/>}
                                onClick={props.onStartNewChatClicked}
                >
                    <GradientText variant={"body2"}>Start Chatting</GradientText>
                </GradientButton>
            </Grid>
        </Grid>
    </Paper>
}

interface NewChatPageProps {
    onStartNewChatClicked: () => void,
    onSamplePromptClick: (prompt: SamplePrompt) => void
}

export default NewChatPage;
